let currentUser = null;

const generateUUID = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return 'guest-' + crypto.randomUUID();  // ← add prefix here too
  }
  return 'guest-' + Math.random().toString(36).substr(2, 9);
};


export function setCurrentUser(user) {
  if (!user) {
    const randId = generateUUID();
    currentUser = { id: randId, name: "Guest" };
    return;
  }
  currentUser = {
    id: user.id,
    name: user.user_metadata?.full_name || user.email || "Guest"  // ← user not currentUser
  };
}

export function getCurrentUserName() {
  return currentUser?.name ?? "Guest";  // simple, clean
}
const guestId = generateUUID(); // ← generated once, stable forever

export function getCurrentUserId() {
  return currentUser?.id ?? guestId;
}


let testDetail = { name: "", detail: {} };


export function setTestDetail(name, detail = {}) {
  testDetail = { name, detail };
}

export function getTestDetail() {
  return testDetail;
}


export function getUserData() {
  let myUserId = getCurrentUserId();
  let myUserName = getCurrentUserName();

  return { myUserId, myUserName };
}